import { getTargetAccountFiles } from "@/apis/v1/target-account";
import { useQuery } from "@tanstack/react-query";
import { ITargetAccountFiles } from "./targetAccounts.interface";
import { filterDataAccordingToAllowedAdvertisers } from "../Advertiser/advertiser.validation";
export const TARGET_ACCOUNT_FILE_KEY = (
  fileType: "domains" | "emails" | "all",
  companyId?: number
) => ["target-account", "files", fileType, companyId];
export function useTargetAccountFiles({
  queryParams,
  enabled = true,
}: {
  queryParams: ITargetAccountFiles;
  enabled?: boolean;
}) {
  return useQuery(
    TARGET_ACCOUNT_FILE_KEY(queryParams.fileType, queryParams.companyId),
    getTargetAccountFiles,
    {
      enabled,
      meta: {
        queryParams,
      },
      select: filterDataAccordingToAllowedAdvertisers("companyId"),
    }
  );
}
